<div>
<nz-row>
  <nz-col nzSpan="12">
    <h2>Breakdown Management</h2>
  </nz-col>
  <nz-col nzSpan="12" style="text-align: right;">
    <button nz-button nzType="default" (click)="exportIncidents()">
      <i nz-icon nzType="download"></i> Export Breakdowns
    </button>
  </nz-col>
</nz-row>


<nz-tabs [(nzSelectedIndex)]="selectedTabIndex" >
  <nz-tab [nzTitle]="openIncidentsTitle">
    <ng-template #openIncidentsTitle>
      Open Breakdowns
      <nz-badge [nzCount]="openIncidents().length"></nz-badge>
    </ng-template>
    <app-open-incident-table   
    [etaChanges]="etaChanges()">
  </app-open-incident-table>

  </nz-tab>

 <nz-tab nzTitle="Closed Breakdowns">  
    <app-closed-incident-table
    [etaChanges]="etaChanges()"
    ></app-closed-incident-table>
  </nz-tab> 

</nz-tabs>
</div>

